module.exports = "<svg viewBox=\"0 0 14 21\" xmlns=\"http://www.w3.org/2000/svg\"><title>Artboard 3</title><path d=\"M13.027 9.085c.843.77.85 2.015.014 2.79l-9.323 8.672c-.84.78-2.213.792-3.068.025-.856-.767-.868-2.022-.028-2.803l7.81-7.3L.638 3.385C-.21 2.61-.213 1.356.634.582c.847-.775 2.22-.776 3.07-.003l9.323 8.505z\" fill=\"#13CB6E\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/images/right-arrow.svg
// module id = kUVr
// module chunks = 89